export default __webpack_public_path__ + "static/media/almostStatus.f400f4b8.svg";